import type { AppRouter } from "@coucou/api";
import { createTRPCClient, httpBatchLink, type TRPCClient } from "@trpc/client";
import superjson from "superjson";
import { loadSession } from "./session";

/** Exportee : le televersement d'images passe par une route hors tRPC. */
export const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3333";

export const SALON_ID =
  import.meta.env.VITE_SALON_ID ?? "11111111-1111-1111-1111-111111111111";

export const SALON_TIMEZONE = import.meta.env.VITE_SALON_TIMEZONE ?? "Europe/Paris";

/**
 * Le desktop n'a pas de cookie jar : il porte le jeton en en-tete `Bearer`.
 * `headers()` est evalue a CHAQUE requete — apres une reconnexion, le nouveau
 * jeton part sans qu'il faille recreer le client.
 */
export const api: TRPCClient<AppRouter> = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${API_URL}/trpc`,
      transformer: superjson,
      headers() {
        const session = loadSession();
        return {
          ...(session ? { authorization: `Bearer ${session.token}` } : {}),
          "x-salon-id": SALON_ID,
        };
      },
    }),
  ],
});
